import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@react-input/mask/module/InputMask.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Button/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CakeMaker"] */ "/vercel/path0/src/components/CakeMaker/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Comment/styles.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/FaqQuestion/styles.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Input/styles.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Navbar/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/RotativeIcon/styles.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Sections/About/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Sections/Faq/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Sections/Flavors/styles.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Sections/Hero/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Textarea/styles.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ThemeToggle/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/hooks/useBreakpoints.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/hooks/useModal.ts");
